<template>
	<div v-if="customerId">
		<!-- <snsMarketingPage v-if="snsShow"></snsMarketingPage> -->
		<!-- v-else -->
		<el-row class="row-bg">
			<el-dropdown
				trigger="click"
				placement="bottom"
				@command="selectWebsite"
				v-if="webList.length"
			>
				<div class="websiteUrl">
					<!-- @click="openUrl" -->
					<span class="websiteUrl_text">{{ websiteUrl }}</span>
					<i class="el-icon-arrow-down"></i>
					<!-- <ig-icon name="jiantou" size="mini" class="jiantou"></ig-icon> -->
				</div>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item
						v-for="item in webList"
						:key="item.id"
						:disabled="item.disabled"
						:command="item"
					>
						<span
							class="dropdown-item"
							:class="item.id === activeWebsite.id ? 'weburlColor' : ''"
							style="display: block"
							>{{ item | toDealWith }}
							<span v-if="item.disabled" class="overdue_text">已过期</span>
						</span>
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</el-row>
		<div class="chat-container" v-if="activeWebsiteId" :key="activeWebsiteId">
			<div style="width: 250px" class="bg">
				<chatSearch
					dialogue
					isAll="全部对话"
					@filter="filter(arguments)"
					@search="search"
					:tabVal="assignmentFlag"
					@typeChange="typeChange"
					ref="mychild"
				></chatSearch>
				<div class="left-list">
					<el-scrollbar class="scroll-bar">
						<list :data="data" @checkone="checklist" :id="summaryId" v-loading="listLoading"></list>
					</el-scrollbar>
				</div>
			</div>
			<div style="flex: 1" class="bg">
				<div v-if="chatNoData" v-loading="loading">
					<chatHeader
						:info="headerInfo"
						:id="summaryId"
						:messengerUserId="messengerUserId"
						:type="type"
						:dataType="dataType"
						:garbageInfo="garbageInfo"
					></chatHeader>
					<chatContent
						:scollFlag="scollFlag"
						:moreTextFlag="moreTextFlag"
						:list="list"
						v-bind="headerInfo"
						v-if="data && data.length > 0 && dataType != '2'"
						@more="contentMore(arguments)"
						@repeatSendFileAction="repeatSendFileAction"
					></chatContent>
					<whatsappChatContent
						:scollFlag="scollFlag"
						:moreTextFlag="moreTextFlag"
						:list="list"
						:headerInfo="headerInfo"
						v-if="data && data.length > 0 && dataType == '2'"
						@more="contentWhatsappMore(arguments)"
					></whatsappChatContent>
					<!-- <skysimplerichtext
						v-model="content"
						:timeFlag="timeFlag"
						:headerInfo="headerInfo"
						ref="richText"
						platform="mail-pub-oss"
						class="simple-richtext"
						@send="sendmsg"
						@upload="upload"
					></skysimplerichtext> -->
				</div>
				<div v-else class="chat-noData">
					<div>
						<ig-icon name="chat" class="chat-icon"></ig-icon>
					</div>
				</div>
			</div>
			<div class="sideBox bg" v-if="chatNoData" v-loading="loading">
				<chatFold
					v-if="!foldVisible"
					@changeSide="changeSide"
					:id="summaryId"
					:messengerUserId="messengerUserId"
					:type="type"
					:tableId="tableId"
					:getData="getCustData"
					:headerInfo="headerInfo"
					:garbageFlag="garbageFlag"
					:logo="logo"
				></chatFold>
				<div v-if="foldVisible && dataType == 1">
					<chatDrawer
						v-if="type == 0"
						:id="summaryId"
						@changeSide="changeSide"
						:messengerUserId="messengerUserId"
						:headerInfo="headerInfo"
						:logo="logo"
					></chatDrawer>
					<customerDrawer
						v-if="type == 2"
						:id="summaryId"
						:headerInfo="headerInfo"
						@changeSide="changeSide"
						:logo="logo"
					></customerDrawer>
					<clueDrawer
						v-if="type == 1"
						:summaryId="summaryId"
						:headerInfo="headerInfo"
						@changeSide="changeSide"
						:tableId="tableId"
						:logo="logo"
					></clueDrawer>
				</div>
				<div v-if="foldVisible && dataType == 2">
					<whatsappDrawer
						:summaryId="summaryId"
						:headerInfo="headerInfo"
						@changeSide="changeSide"
						:tableId="tableId"
						:dataType="dataType"
						:logo="logo"
					></whatsappDrawer>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getPape } from '@/common/snsPage';
// import snsMarketingPage from '@/backend/pages/socialMedia/snsMarketingPage.vue';
// import skysimplerichtext from '@/components/iglobalwin/formComponents/sky-simplerichtext.vue';
import chatContent from '@/components/chat/chat-content.vue';
import chatHeader from '@/components/chat/chat-header.vue';
import clueDrawer from '@/components/chat/drawer/clue-drawer.vue';
import customerDrawer from '@/components/chat/drawer/customer-drawer.vue';
import chatDrawer from '@/components/chat/drawer/chat-drawer.vue';
import chatSer from '@/backend/services/chat/chatSer.js';
import list from '@/components/chat/components/list.vue';
import chatSearch from '@/components/chat/chat-search.vue';
import { mapGetters } from 'vuex';
import { getHoursMinutes, getTodayDate } from '@/common/util.js';
import mixinsWatch from '@/client/mixinsWatch/mixinsWatch';
import chatFold from '@/components/chat/fold/chatFold.vue';
import whatsappChatContent from '@/components/chat/whatsapp-chat-content.vue';
import whatsappDrawer from '@/components/chat/drawer/whatsapp-drawer.vue';
export default {
	mixins: [mixinsWatch],
	data() {
		return {
			content: '',
			list: [],
			summaryId: '',
			type: 1,
			noData: false,
			tableId: '',
			logo: '',
			psid: '',
			pageId: '',
			firstTime: '',
			garbageFlag: 0,
			timeFlag: false,
			randomStr: '',
			random_str: '',
			timestamp: 0,
			username: '',
			password: '',
			data: [],
			userType: 1,
			headerInfo: {},
			drawerVisible: false,
			displayStart: 1,
			followupName: '', //跟进人标识
			checkChat: false,
			checkCustomer: false,
			checkHighseasCustomer: false,
			checkRubbishInquiry: false,
			checkInquiry: false,
			checkType: true,
			messengerUserId: null,
			fbName: '',
			queryChatNoData: true,
			snsShow: false,
			sendfileType: null,
			loading: false,
			recordIdLast: '',
			sendTimeLast: '',
			moreTextFlag: true,
			scollFlag: false,
			assignmentFlag: false,
			listLoading: false,
			getCustData: {},
			foldVisible: true,
			loadingFlag: false,
			chatNoData: false,
			allReadyDataType: '',
			dataType: '',
			garbageInfo: {},
		};
	},
	computed: {
		...mapGetters([
			// 'chatVisible',
			'allChatList',
			// 'chatNoData',
			'userInfo',
			'customerId',
			'webList',
			'activeWebsite',
			'activeWebsiteId',
		]),
		websiteUrl() {
			let { activeWebsite } = this;
			let { name } = activeWebsite;
			if (name) return activeWebsite && activeWebsite.name;
			else return activeWebsite && activeWebsite.serviceCode;
		},
	},
	async mounted() {
		// this.snsShow = await getPape();
	},
	filters: {
		toDealWith: function (value) {
			let { name, serviceCode } = value;
			if (name) return name;
			else return serviceCode;
		},
	},
	watch: {
		customerId: {
			async handler(val) {
				let id = this.$route.query.id;
				let name = this.$route.query.name;

				if (id && name) {
					this.getDataList();
				}
				if (!val) {
					this.$message.warning('您需要先选择一个客户');
				}
			},
			immediate: true,
		},
		activeWebsiteId: {
			handler(val) {
				if (val) {
					sessionStorage.setItem('activeWebsiteId', val);
				}
			},
		},
	},
	methods: {
		changeSide(val) {
			this.foldVisible = !val;
		},
		async selectWebsite(obj) {
			this.$store.commit('SET_ACTIVEWEBSITE', obj);
			sessionStorage.setItem('activeWebsiteId', obj.id);
		},
		typeChange(val) {
			this.dataType = val;
			this.allReadyDataType = val;
			this.getDataList();
			this.$store.dispatch('setChatNoData', false);
		},
		fileNameReg(str, record) {
			//1.文本消息2.图片，3.视频,4.文件，5弹窗
			let flag = true;
			str = str.toLowerCase();
			//str参数是整个文件名
			var regImg = /\.(png|jpg|gif|jpeg|webp)+$/;
			if (regImg.test(str)) {
				flag = false;
				return record ? 2 : 1;
			}
			var regVideo = /\.(avi|wmv|mpg|mpeg|mov|rm|ram|swf|flv|mp4|mp3|wma|rm|rmvb|flv|mpg|mkv)$/;
			if (regVideo.test(str)) {
				flag = false;
				return 3;
			}
			var regFile = /\.(ppt|txt|doc|pdf|zip|rar|html|exe|tmp|xls|apk|xmind)$/;
			if (regFile.test(str)) {
				flag = false;
				return 4;
			}
			if (flag) {
				return 4;
			}
		},
		async upload(info) {
			//对聊天记录拼接文件和图片
			//1.文本消息2.图片，3.视频,4.文件，5弹窗
			if (info.sendType == 1) {
				this.list.push({
					fbName: this.userInfo.userName,
					fbThumb: this.userInfo.userAvatar,
					recordId: '',
					sendTime: getTodayDate('YYYY-MM-DD HH:mm:ss'),
					senderType: 2, //收发类型(1:客户发送,2:主页发送)
					contentList: [
						{
							content: '',
							fileName: info.name,
							fileSizeStr: info.fileSize,
							sendType: 1, //发送状态(1:发送中;2:发送成功;3:发送失败;)
							temp: '',
							type: this.fileNameReg(info.name, true),
							urls: info.url,
						},
					],
				});
			}
			//上传成功
			if (info.sendType == 2) {
				//调发送接口
				let param = {
					id: this.summaryId, //线索/客户id
					fileName: info.name,
					fileSize: info.size,
					inquiryOrCustomerType: this.type, //操作类型(0:聊天;1:线索;2:客户;)
					isAffix: 1, //是否存在附件(0,否;1,只存在附件;2,文本附件同时存在)
					messengerUserId: this.messengerUserId,
					pageId: this.pageId, //fb主页id
					psid: this.psid, //fb客户和主页唯一对应id
					text: '', //文本消息内容
					type: this.fileNameReg(info.name), //附件类型(1,image;2,audio;3,video;4,file)
					url: info.url, //文件url
				};
				await chatSer.chatSend(param);
				this.getRecord();
			}
		},
		async requestData() {
			// this.snsShow = await getPape();
			if (this.customerId && this.activeWebsiteId) {
				this.getDataList();
			}
		},
		contentMore(arg) {
			this.recordIdLast = arg[1];
			this.sendTimeLast = arg[2];
			this.getRecord(arg[0], true);
		},
		contentWhatsappMore(arg) {
			this.recordIdLast = arg[1];
			this.sendTimeLast = arg[2];
			this.getWhatsappRecord(arg[0], true);
		},
		setVisible() {
			this.drawerVisible = !this.drawerVisible;
		},
		filter(arg) {
			this.checkChat = arg[0];
			this.checkCustomer = arg[1];
			this.checkHighseasCustomer = arg[2];
			this.checkRubbishInquiry = arg[3];
			this.checkInquiry = arg[4];
			if (arg[0] || arg[1] || arg[2] || arg[3] || arg[4]) {
				this.checkType = false;
			} else {
				this.checkType = true;
			}
			this.assignmentFlag = arg[5];
			this.getDataList();
			this.summaryId = '';
			this.chatNoData = false;
			// this.$store.dispatch('setChatNoData', false);
		},
		search(val) {
			this.loadingFlag = true;
			this.checkone(val);
		},
		async getDataList(flag = true) {
			this.loading = true;
			let param = {
				dialogue: 1, //对话(0,我的对话;1,全部对话)
				displayLength: 1000,
				displayStart: 1,
				name: '',
				checkChat: this.checkChat ? 1 : 0,
				checkCustomer: this.checkCustomer ? 1 : 0,
				checkHighseasCustomer: this.checkHighseasCustomer ? 1 : 0,
				checkRubbishInquiry: this.checkRubbishInquiry ? 1 : 0,
				checkInquiry: this.checkInquiry ? 1 : 0,
				checkType: this.checkType ? 1 : undefined, //是否查看全部数据类型(0:未读;1:是;)
				assignmentFlag: this.assignmentFlag ? 1 : 0, //是否分配(0,否;1,是)
				dataType: this.allReadyDataType,
			};
			this.listLoading = true;
			try {
				let res = await chatSer.chatList(param);
				this.listLoading = false;
				this.data = res.data.data;
				this.loading = false;
				// this.$store.dispatch('setAllChatList', this.data);
				if (flag && this.queryChatNoData) {
					this.chatNoData = false;
					// this.$store.dispatch('setChatNoData', false);
				} else {
					this.$refs.mychild.reset();
				}
			} catch (error) {
				this.listLoading = false;
			}
		},
		//聊天列表数据拼接
		chatDataHand(obj, summaryId) {
			let flag = this.data.find(e => e.id == summaryId);
			if (!flag) {
				this.data.push(obj);
				// this.$store.dispatch('setAllChatList', this.data);
			} else {
				let findflag = false;
				this.data.forEach(e => {
					if (e.id == summaryId) {
						findflag = true;
						e.msgContent = obj.msgContent;
						e.latelyTimeStr = obj.latelyTimeStr;
						e.msgNum = this.summaryId == summaryId ? '' : obj.msgNum;
						obj = { ...e };
					}
				});
				if (findflag) {
					let index = this.data.findIndex(e => e.id == summaryId);
					this.data.splice(index, 1);
					this.data.unshift(obj);
				}

				// this.$store.dispatch('setAllChatList', this.data);
			}
		},
		//重新发送文件
		async repeatSendFileAction(info) {
			//1.文本消息2.图片，3.视频,4.文件，5弹窗
			this.list.forEach(e => {
				if (e.contentList[0].contentId == info.contentList[0].contentId) {
					e.contentList[0].sendType = 1;
				}
			});
			//调发送接口
			let param = {
				infoId: info.recordId,
				contentId: info.contentList[0].contentId,
				id: this.summaryId, //线索/客户id
				fileName: info.contentList[0].fileName,
				fileSize: info.contentList[0].fileSize,
				inquiryOrCustomerType: this.type, //操作类型(0:聊天;1:线索;2:客户;)
				isAffix: 1, //是否存在附件(0,否;1,只存在附件;2,文本附件同时存在)
				messengerUserId: this.messengerUserId,
				pageId: this.pageId, //fb主页id
				psid: this.psid, //fb客户和主页唯一对应id
				text: '', //文本消息内容
				type: this.fileNameReg(info.contentList[0].fileName), //附件类型(1,image;2,audio;3,video;4,file)
				url: info.contentList[0].urls, //文件url
			};
			await chatSer.chatSend(param);
			this.getRecord();
		},
		async sendmsg(val) {
			if (val) {
				this.content = '';
				let reg = new RegExp('&nbsp;', 'g'); //g代表全部
				let value = val.replace(reg, '\u3000');
				let param = {
					id: this.summaryId,
					isAffix: 0, //是否存在附件(0,否;1,只存在附件;2,文本附件同时存在)
					inquiryOrCustomerType: this.type == 2 ? 1 : 0, //操作类型(0,线索;1,客户)
					text: value,
					psid: this.psid,
					pageId: this.pageId,
					messengerUserId: this.messengerUserId,
				};
				let res = await chatSer.chatSend(param);
				if (res.data) {
					this.list.push({
						fbName: this.userInfo.userName,
						fbThumb: this.userInfo.userAvatar,
						recordId: res.data.infoId,
						sendTime: getTodayDate('YYYY-MM-DD HH:mm:ss'),
						senderType: 2,
						contentList: [
							{
								content: value,
								temp: '',
								type: 1,
								urls: '',
							},
						],
					});
					let obj = {
						msgContent: value,
						latelyTimeStr: getHoursMinutes(),
						msgNum: '',
					};
					this.chatDataHand(obj, this.summaryId);
				}
			} else {
				this.content = '';
			}
		},
		checklist(item) {
			this.drawerVisible = false;
			//从未读消息跳过来
			if (item) {
				let { garbageFlag, garbageReason } = item;

				this.content = '';
				this.chatNoData = true;
				// this.$store.dispatch('setChatNoData', true);
				this.type = item.type;
				this.summaryId = item.id; //线索id传给fb
				this.tableId = item.tableId; //summaryId
				this.messengerUserId = item.messengerUserId || '';
				this.dataType = item.dataType;
				this.fbName = item.title || '';

				this.garbageInfo = {
					garbageFlag,
					garbageReason,
				};

				if (item.headPath) {
					this.logo = item.headPath;
				} else {
					this.logo = '';
				}
				this.loadingFlag = true;
				if (item.dataType == 2) {
					this.getWhatsappRecord();
				} else {
					this.getRecord(); //聊天内容
				}
				this.getData(); //头部详情
			} else {
				this.chatNoData = false;
				// this.$store.dispatch('setChatNoData', false);
			}
		},
		checkone(item) {
			this.drawerVisible = false;
			if (item) {
				let index = 0;
				this.data.forEach((ele, i) => {
					if (ele.id == item.id) {
						ele.msgNum = 0;
						index = i;
					}
				});
				// this.$store.dispatch('setAllChatList', this.allChatList);
				this.chatNoData = true;
				// this.$store.dispatch('setChatNoData', true);
				this.type = item.type;
				this.summaryId = item.id; //线索id传给fb
				this.tableId = item.tableId; //summaryId
				this.messengerUserId = item.messengerUserId || '';
				this.fbName = item.title || '';
				if (item.headPath) {
					this.logo = item.headPath;
				} else {
					this.logo = '';
				}

				this.getRecord(); //聊天内容
				this.getData(); //头部详情
				this.$nextTick(() => {
					document.getElementById(`${index}`).scrollIntoView();
				});
			} else {
				this.chatNoData = false;
				// this.$store.dispatch('setChatNoData', false);
			}
		},
		//分页？
		async getRecord(displayStart = 1, flag = false) {
			try {
				this.loading = this.loadingFlag;
				let condition = this.type == 0;
				let res = await chatSer.chatRecord({
					id: this.summaryId,
					type: this.type,
					recordId: flag ? this.recordIdLast : '',
					sendTime: flag ? this.sendTimeLast : '',
					displayLength: 10,
					...(condition && { messengerUserId: this.messengerUserId }),
				});
				if (res) {
					this.scollFlag = flag;
					if (flag) {
						this.moreTextFlag = res.data.data && res.data.data.length > 0 ? true : false;
						this.list = res.data.data.reverse().concat(this.list);
					} else {
						this.moreTextFlag = true;
						this.list = res.data.data.reverse();
					}
					this.loading = false;
					this.chatNoData = true;
					// this.$store.dispatch('setChatNoData', true);
				} else {
					this.list = [];
					this.moreTextFlag = false;
					this.loading = false;
					this.chatNoData = false;
					// this.$store.dispatch('setChatNoData', false);
				}
			} catch (error) {
				this.list = [];
				this.loading = false;
				this.chatNoData = false;
				// this.$store.dispatch('setChatNoData', false);
			}
		},
		// 获取whatsapp聊天记录
		async getWhatsappRecord(displayStart = 1, flag = false) {
			// whatsappChatRecord
			try {
				this.loading = this.loadingFlag;
				let params = {
					id: this.summaryId,
					type: this.type,
					recordId: flag ? this.recordIdLast : '',
					sendTime: flag ? this.sendTimeLast : '',
					displayLength: 10,
					whatsappUserId: this.messengerUserId,
				};
				let res = await chatSer.whatsappChatRecord(params);
				if (res) {
					this.scollFlag = flag;
					res.data.data = res.data.data.filter(item => {
						return item.contentList;
					});
					if (flag) {
						this.moreTextFlag = res.data.data && res.data.data.length > 0 ? true : false;
						this.list = res.data.data.reverse().concat(this.list);
						// this.list = res.data.data.reverse();
					} else {
						this.moreTextFlag = true;
						this.list = res.data.data.reverse();
					}
					this.loading = false;
					this.chatNoData = true;
				} else {
					this.list = [];
					this.moreTextFlag = false;
					this.loading = false;
					this.chatNoData = true;
				}
			} catch (error) {
				console.log(error);
				this.loading = false;
				this.chatNoData = true;
			}
		},
		async getData() {
			let res = await chatSer.headerDetail({
				id: this.summaryId,
				type: this.type,
			});
			// this.$store.dispatch('getchatUnread');
			// this.$store.dispatch('getNum');
			this.headerInfo = res.data;
			this.psid = res.data.psid;
			this.pageId = res.data.pageId;
			this.firstTime = res.data.firstTime;
			this.userType = res.data.userType;
			this.garbageFlag = res.data.garbageFlag;
			this.getCustData = {
				customerId: res.data.id,
				customerName: res.data.nickname,
			};
			let timeNum;
			if (this.userType == 1) {
				timeNum = 24 * 60 * 60 * 1000;
			} else {
				timeNum = 24 * 60 * 60 * 1000 * 7;
			}
			const endTime = Date.parse(new Date(this.firstTime)) + timeNum;
			const nowTime = Date.parse(new Date(this.firstTime));
			var date = new Date();
			var now = date.getTime(nowTime);
			//设置截止时间
			var endDate = new Date(endTime);
			var end = endDate.getTime();
			//时间差
			var rightTime = end - now; //截止时间减去当前时间
			if (rightTime > 0) {
				this.timeFlag = false;
			} else {
				this.timeFlag = true;
			}
		},
		typeChange(val) {
			this.dataType = val;
			this.allReadyDataType = val;
			this.getDataList();
		},
	},
	components: {
		chatContent,
		// skysimplerichtext,
		chatHeader,
		clueDrawer,
		customerDrawer,
		list,
		chatSearch,
		chatDrawer,
		// snsMarketingPage,
		chatFold,
		whatsappChatContent,
		whatsappDrawer,
	},
};
</script>
<style lang="scss" scoped>
.moreText {
	font-size: 10px;
	text-align: center;
	color: #3da1ff;
	cursor: pointer;
	padding: 10px 0px;
}

.chat-container {
	/* margin: 0px 20px; */
	display: flex;
	height: calc(100vh - 120px);
	::v-deep .el-scrollbar__wrap {
		overflow-x: hidden;
	}
	.bg {
		background: #fff;
	}
}
.left-list {
	height: calc(100vh - 235px);
	// height: 200px;
	border-right: 1px #e8e8e8 solid;
}
.scroll-bar {
	height: 100%;
	overflow-x: hidden;
}
.simple-richtext {
	border-top: 1px #e8e8e8 solid;
	margin-top: 15px;
}
.chat-noData {
	flex: 1;
	text-align: center;
	div {
		margin-top: 23%;
		.chat-icon {
			font-size: 120px;
			color: #eeeeee;
		}
	}
}
.sideBox {
	margin-left: 10px;
}
</style>
